import React from 'react';
import { connect } from 'react-redux';

import { setDataReload } from '../../../redux/actions/setDataReload';

import WindowQuery from '../../WindowQuery';
import IconButton from '../../buttons/IconButton';

import { VIEW } from '../../../constants/appConstants';

import './HomeView.css';

const HomeView = (props) => {
    const switchToMyView = () => {
        props.setDataReload(true);
        props.switchView(VIEW.MY_WINDOW_VIEW);
    }

    const switchToNewWinView = () => {
        props.switchView(VIEW.NEW_WINDOW_VIEW);
    }

    return (
        <div className='clsHomeView'>
            <WindowQuery setView = { props.switchView } />
            { props.isAuthorized ? 
                <div className='clsButtonWrapper'>
                    <IconButton 
                        icon = { 'fa-plus-circle' }
                        label = { 'New Window'}
                        color = { '#316f1b' }  
                        onClick = { switchToNewWinView } />
                    <IconButton 
                        icon = { 'fa-user-circle' }
                        label = { 'My Windows'}
                        color = { '#864b0f' } 
                        onClick = { switchToMyView } />
                </div> : null }
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        isAuthorized: state.isAuthorized
    };
  }
  
const mapDispatchToProps = dispatch => {
    return {
        setDataReload: (reload) => dispatch(setDataReload(reload))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeView);